// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__gqiNk","row":"Node_row__MTFHg","label":"Node_label__1dGNv","footer":"Node_footer__JIvL7"};